const SCREENSHOT_SERVICE = 'https://ts.paperform.app/';
module.exports = function formScreenshot(slug, opts) {
  if (!slug) {
    return null;
  }
  opts.form = slug;
  // increment the version to break the screenshot cache
  opts.version = 1;

  const qs = [
    'form',
    'width',
    'height',
    'screenWidth',
    'screenHeight',
    'fullPage',
    'version'
  ]
    .reduce((qs, prop) => {
      if (opts[prop]) {
        qs += `${prop}=${encodeURIComponent(opts[prop])}&`;
      }
      return qs;
    }, '?')
    .slice(0, -1);
  return SCREENSHOT_SERVICE + qs;
};
